import { render, staticRenderFns } from "./LeftNavigationBar.vue?vue&type=template&id=4cdcf2bb"
import script from "./LeftNavigationBar.vue?vue&type=script&lang=ts"
export * from "./LeftNavigationBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports